module.exports = __webpack_public_path__ + "media/src/PriceCalculator/images/alarm-clock-91bdf4d920ccc8484486643be5885290.svg";